import { useRouter } from 'next/router';

import { useGlobalStore } from '../state/globalStore';
import { ENTITY_TYPE, PREVIEW_TYPE } from '../utils/constants';
import { Enum } from '../utils/types';

export const useRouterPath = () => {
  const router = useRouter();
  const setPreviewType = useGlobalStore((store) => store.setPreviewType);
  const entityType = useGlobalStore((store) => store.entityType);

  const onPreviewChange = (path: Enum<typeof PREVIEW_TYPE>) => {
    const url = router.asPath.replace(/\/$/, '');
    const lastParam = url.split('/').pop() as Enum<typeof PREVIEW_TYPE>;
    if (Object.values(PREVIEW_TYPE).includes(lastParam) && entityType === ENTITY_TYPE.VIDEO) {
      const newUrl = url.replace(lastParam, path);
      router.push(newUrl);
    }
    setPreviewType(path);
  };
  return { onPreviewChange };
};
